<template lang="pug">
tooltip-wrap(
  :text="chip.title"
)
  v-chip(
    dark
    v-bind="$attrs"
    :color="chip.color"
    :style="icon ? 'padding: 5px' : ''"
  )
    template(v-if="!icon")
      span.mr-2 {{ chip.title }}
    v-icon(size="22") {{ chip.name }}
</template>
<script>

const recommendationIcons = {
  questionnaire: {
    name: 'mdi-ballot-outline',
    title: 'Анкета',
    color: 'info',
  },
  program: {
    name: 'mdi-book-open-page-variant-outline',
    title: 'Программа',
    color: 'light-green',
  },
  practice: {
    name: 'mdi-file-document-outline',
    title: 'Практика',
    color: 'deep-orange',
  },
  receipt: {
    name: 'mdi-file-link-outline',
    title: 'Рекомендация',
    color: 'amber darken-1',
  },
};

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    icon: { type: Boolean, default: false },
  },
  data() {
    return {
      // recommendationIcons,
    };
  },
  computed: {
    chip() {
      return recommendationIcons[this.type];
    },
  },
};
</script>
